import React from 'react'

export default function RenderMonitorItem({
  url = '',
  accessToken = ''
}) {
  const src = `https://open.ys7.com/ezopen/h5/iframe?url=${url}&autoplay=1&accessToken=${accessToken}`
  return (
    <iframe
      src={src}
      width="100%"
      height="100%"
      allowFullScreen
    />
  )
}